import classNames from 'classnames';
import { forwardRef } from 'react';

export interface CardProps {
  className?: string;
  variant?: 'shadowed' | 'elevated' | 'bordered' | 'borderless';
  overflowX?: boolean;
  active?: boolean;
}

export const Card = forwardRef<HTMLElement, React.PropsWithChildren<CardProps>>(
  ({ className, children, variant = 'shadowed', active = false, overflowX = true, ...props }, ref) => {
    return (
      <article
        ref={ref}
        className={classNames(
          'relative flex flex-col  dark:bg-gray-800 rounded-lg transition ease-in-out duration-150 overflow-hidden border border-solid border-border',
          overflowX ? 'overflow-x-auto' : undefined,
          variant === 'shadowed' ? 'shadow-md bg-surface-base' : undefined,
          variant === 'elevated' ? 'shadow-[1px_1px_10px_0_rgba(0,0,0,0.15)] bg-surface-elevated' : undefined,
          variant === 'bordered' ? 'border border-solid border-border' : undefined,
          variant === 'borderless' ? 'border-none' : undefined,
          active ? 'ring-4 ring-cyan-600 dark:ring-cyan-500' : undefined,
          className,
        )}
        {...props}
      >
        {children}
      </article>
    );
  },
);

export default Card;
